module.exports = __webpack_public_path__ + "assets/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/favicon.ico
// module id = 933
// module chunks = 17